import { postJobValid } from "../../validation/postjob";
import { useEffect, useState, useCallback, useMemo, useRef } from "react";
import { toastError, toastSuccess } from "../../config/ToastModal";
import isEmpty from "../../lib/isEmpty";
import Select from "react-select";
import { GetCountries, GetState, GetCity } from "react-country-state-city";
import {
  GetJobCategories,
  getSingleJob,
  jobPost,
  jobUpdate,
  LanguageGetCreate,
  getProfile,
} from "../../services/auth";
import moment from "moment";
import styles from "./Postjobs.module.scss";
import Createcategory from "./CreateCategory";
import Modal from "react-bootstrap/Modal";
import CreateLanguage from "./CreateLanguage";
import { useNavigate, useSearchParams } from "react-router-dom";

// import JoditEditor from "jodit-react";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import Quill styles

const initialstateValue = {
  title: "",
  description: "",
  email: "",
  userName: "",
  // jobType: "TEACHER",
  experienceFrom: "",
  experienceTo: "",
  skills: [],
  employmentType: "",
  // qualification: "",
  openings: "",
  gender: "",
  deadlineDate: "",
  workType: "",
  country: "",
  state: "",
  city: "",
  address: "",
  phoneNo: "",
  fromSalary: "",
  toSalary: "",
  website: "",
  JobCategory: "",
  salaryRangeMin: "",
  salaryRangeMax: "",
  jobStatus: "active",
  timeline: "",
};

const PostBoxForm = () => {
  const router = useNavigate();

  const [searchQueryId] = useSearchParams();

  const idGet = searchQueryId.get("jobId");
  const [id, setId] = useState("");

  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({});
  const [formValues, setFormValues] = useState(initialstateValue);
  const [countryId, setCountryId] = useState("");
  const [stateId, setStateId] = useState("");
  const [cityId, setCityId] = useState("");

  const [countriesList, setCountriesList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);

  // qualifications state

  const [qualifications, setQualifications] = useState([]);
  const [qualification, setQualification] = useState("");

  const [content, setContent] = useState("");
  const [logs, setLogs] = useState([]);
  const appendLog = useCallback(
    (message) => {
      const newLogs = [...logs, message];
      setLogs(newLogs);
    },
    [logs, setLogs]
  );

  // key skills

  const [keyskills, setKeySkills] = useState([]);
  const [keyskill, setKeySkill] = useState("");

  const [profileDetail, setProfileDetail] = useState({});
  const [socialData, setSocialData] = useState({});
  const [contactData, setContactData] = useState({});

  const [status, setStatus] = useState("");
  const [user, setUserData] = useState([]);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [show1, setShow1] = useState(false);

  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);

  const fetchApplicant = async () => {
    try {
      const data = await getProfile();
      setUserData(data?.data);
      setProfileDetail(data?.data?.profileDetail);
      setSocialData(data?.data?.socialNetwork);
      setContactData(data?.data?.contactDetails);
      if (data?.data?.updateStatus) setStatus(data?.data?.updateStatus);
    } catch (error) {}
  };

  const [specialisms, setSpecialisms] = useState(null);

  const fecthLanguageApi = async () => {
    try {
      const response = await LanguageGetCreate();
      if (response) {
        setSpecialisms(response?.data);
      }
    } catch (error) {}
  };

  useEffect(() => {
    fecthLanguageApi();
  }, [profileDetail]);

  // const specialisms = [
  //   { value: "Assamese", label: "Assamese" },
  //   { value: "Bengali", label: "Bengali" },
  //   { value: "Bihari", label: "Bihari" },
  //   { value: "Bhojpuri", label: "Bhojpuri" },
  //   { value: "Dogri", label: "Dogri" },
  //   { value: "English", label: "English" },
  //   { value: "Gujarati", label: "Gujarati" },
  //   { value: "Hindi", label: "Hindi" },
  //   { value: "Kannada", label: "Kannada" },
  //   { value: "Kashmiri", label: "Kashmiri" },
  //   { value: "Konkani", label: "Konkani" },
  //   { value: "Malayalam", label: "Malayalam" },
  //   { value: "Marathi", label: "Marathi" },
  //   { value: "Manipuri (Meitei)", label: "Manipuri (Meitei)" },
  //   { value: "Nepali", label: "Nepali" },
  //   { value: "Odia", label: "Odia" },
  //   { value: "Punjabi", label: "Punjabi" },
  //   { value: "Sanskrit", label: "Sanskrit" },
  //   { value: "Sindhi", label: "Sindhi" },
  //   { value: "Tamil", label: "Tamil" },
  //   { value: "Telugu", label: "Telugu" },
  //   { value: "Urdu", label: "Urdu" },
  //   { value: "Santali", label: "Santali" },
  //   { value: "Bodo", label: "Bodo" },
  //   { value: "Maithili", label: "Maithili" },
  //   { value: "Lepcha", label: "Lepcha" },
  //   { value: "Mizo", label: "Mizo" },
  //   { value: "Nagamese", label: "Nagamese" },
  //   { value: "French", label: "French" },
  //   { value: "Arabic", label: "Arabic" },
  // ];

  const {
    title,
    description,
    email,
    userName,
    // jobType,
    experienceFrom,
    experienceTo,
    skills,
    employmentType,
    // qualification,
    openings,
    JobCategory,
    gender,
    deadlineDate,
    workType,
    country,
    state,
    city,
    address,
    phoneNo,
    fromSalary,
    toSalary,
    website,
    salaryRangeMax,
    salaryRangeMin,
    jobStatus,
    timeline,
  } = formValues;

  useEffect(() => {
    fetchApplicant();
  }, []);

  const handleBlur = ({ target: { name } }) => {
    setTouched({ ...touched, [name]: true });
  };

  const handleChange = ({ target: { name, value } }) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSelectChange = (selectedOptions) => {
    const selectedValues = specialisms.map((option) => option);
    setFormValues({ ...formValues, skills: selectedOptions });
  };

  const handleSelectBlur = () => {
    setTouched((prevTouched) => ({ ...prevTouched, skills: true }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const experience = `${experienceFrom ? experienceFrom : 0}-${
      experienceTo ? experienceTo : 0
    }`;
    if (id) {
      try {
        const data = {
          _id: id,
          title,
          description: content,
          email,
          // jobType,
          // experience,
          language: skills.map((item) =>
            typeof item === "string" ? item : item?.value
          ),
          employmentType,
          qualification: qualifications,
          keySkills: keyskills,
          gender,
          deadlineDate,
          workType,
          country: country ? country : getData?.contactDetails?.country,
          state,
          city,
          address,
          phoneNo,
          salaryRangeMin,
          salaryRangeMax,
          website,
          JobCategory,
          openings,
          status: jobStatus,
          timeline,
          experienceFrom,
          experienceTo,
        };
        if (
          data?.title &&
          data?.description &&
          data?.email &&
          data?.experienceFrom &&
          data?.experienceTo &&
          data.language?.length > 0 &&
          data.employmentType &&
          data.qualification?.length > 0 &&
          data.gender &&
          data.keySkills?.length > 0 &&
          data.deadlineDate &&
          data.workType &&
          data.country &&
          data.state &&
          data.city &&
          data.address &&
          data.phoneNo &&
          data.salaryRangeMax &&
          data.salaryRangeMin &&
          data.JobCategory &&
          data.openings &&
          data.status &&
          data.timeline
        ) {
          if (Number(experienceFrom) < Number(experienceTo)) {
            if (Number(salaryRangeMin) < Number(salaryRangeMax)) {
              const { status, message, errors } = await jobUpdate(data);
              if (status == true) {
                toastSuccess(message);
                router("/manage-jobs");
              } else if (status == false && message) {
                toastError(message);
              } else if (errors) {
                setErrors(errors);
                Object.keys(errors).map((item) => {
                  Object.keys(formValues).map((items, index) => {
                    if (item == items) {
                      toastError(errors[items]);
                    }
                  });
                });
              }
            } else {
              toastError("Min Salary cannot be greater than Max Salary");
            }
          } else {
            toastError("Invalid range: start experience > end experience.");
          }
        } else {
          toastError("Please fill in all the fields.");
        }
      } catch (err) {
        console.log(err);
      }
    } else {
      try {
        const data = {
          title,
          description: content,
          email,
          // jobType,
          // experience,
          language: skills.map((item) =>
            typeof item === "string" ? item : item?.value
          ),
          employmentType,
          qualification: qualifications,
          gender,
          keySkills: keyskills,
          deadlineDate,
          workType,
          country,
          state,
          city,
          address,
          phoneNo,
          salaryRangeMin,
          salaryRangeMax,
          website,
          JobCategory,
          openings,
          status: jobStatus,
          timeline,
          experienceFrom,
          experienceTo,
        };

        if (
          data?.title &&
          data?.description &&
          data?.email &&
          data?.experienceFrom &&
          data?.experienceTo &&
          data.language?.length > 0 &&
          data.employmentType &&
          data.qualification?.length > 0 &&
          data.gender &&
          data.keySkills?.length > 0 &&
          data.deadlineDate &&
          data.workType &&
          data.country &&
          data.state &&
          data.city &&
          data.address &&
          data.phoneNo &&
          data.salaryRangeMax &&
          data.salaryRangeMin &&
          data.JobCategory &&
          data.openings &&
          data.status &&
          data.timeline
        ) {
          if (Number(experienceFrom) < Number(experienceTo)) {
            if (Number(salaryRangeMin) < Number(salaryRangeMax)) {
              const { status, message, errors } = await jobPost(data);
              if (status == true) {
                router("/manage-jobs");
                toastSuccess(message);
                router("/manage-jobs");
              } else if (status == false && message) {
                toastError(message);
              } else if (errors) {
                setErrors(errors);
                const errorMessages = Object.values(errors).join("\n");
                toastError(errorMessages);
              }
            } else {
              toastError("Min Salary cannot be greater than Max Salary");
            }
          } else {
            toastError("Invalid range: start experience > end experience.");
          }
        } else {
          toastError("Please fill in all the fields.");
        }
      } catch (err) {}
    }
  };
  const [getData, setGetData] = useState(null);

  const getFetchData = async (id) => {
    try {
      const sendId = {
        jobPostId: id,
      };
      const data = await getSingleJob(sendId);

      const splitQualifications = data?.data?.qualification;
      const spilitKeyskills = data?.data?.keySkills;
      if (splitQualifications && spilitKeyskills) {
        // const splitArrayQualification = splitQualifications.split(",");

        setQualifications(splitQualifications);
        setKeySkills(spilitKeyskills);
      }
      setGetData(data?.data);
    } catch (err) {}
  };

  useEffect(() => {
    if (getData?.contactDetails?.country) {
      const selectedCountry = countriesList.find(
        (item) => item.name === getData?.contactDetails?.country
      );
      if (selectedCountry) {
        setCountryId(selectedCountry.id);
        setFormValues((prevValue) => ({
          ...prevValue,
          country: selectedCountry.name,
        }));
        GetState(selectedCountry.id).then((result) => {
          setStateList(result);
          if (getData?.contactDetails?.state) {
            const selectedState = result.find(
              (item) => item.name === getData?.contactDetails?.state
            );
            if (selectedState) {
              setStateId(selectedState.id);
              setFormValues((prevValue) => ({
                ...prevValue,
                state: selectedState.name,
              }));
              GetCity(selectedCountry.id, selectedState.id).then((result) => {
                setCityList(result);
                if (getData?.contactDetails?.city) {
                  const selectedCity = result.find(
                    (item) => item.name === getData?.contactDetails?.city
                  );
                  if (selectedCity) {
                    setCityId(selectedCity.id);
                    setFormValues((prevValue) => ({
                      ...prevValue,
                      city: selectedCity.name,
                    }));
                  }
                }
              });
            }
          }
        });
      }
    }
    if (getData) {
      const splitSalary = getData?.salary.split("-");
      // const splitExperience = getData?.experience?.split("-");

      // Set skills array
      const skills = getData?.language.map((item) => ({
        label: item,
        value: item,
      }));
      // Set other form values

      setFormValues({
        experienceFrom: getData?.experienceFrom || "",
        experienceTo: getData?.experienceTo || "",
        JobCategory: getData?.categoryId,
        title: getData?.title,
        description: getData?.description,
        email: getData?.email,
        // userName: getData?.userName,
        // jobType: getData?.jobType,
        // experience: getData?.ex,
        skills: skills,
        employmentType: getData?.employmentType,
        qualification: getData?.qualification,
        gender: getData?.gender,
        deadlineDate: moment(getData?.deadlineDate).format("YYYY-MM-DD"),

        // deadlineDate: moment(getData?.deadlineDate).format("MM.DD.YYYY"),
        workType: getData?.workType,
        address: getData?.contactDetails?.address,
        phoneNo: getData?.contactDetails?.phoneNo,
        fromSalary: getData?.salary,
        salaryRangeMax: getData?.salaryRangeMax || splitSalary[1],
        salaryRangeMin: getData?.salaryRangeMin || splitSalary[0],
        // toSalary: getData?.toSalary,
        website: getData?.contactDetails?.website,
        openings: getData?.openings,
        jobStatus: getData?.status,
        timeline: getData?.timeline,
      });

      setContent(getData?.description);
    }
  }, [getData]);

  useEffect(() => {
    GetCountries().then((result) => {
      setCountriesList(result);
    });
  }, [getData]);

  useEffect(() => {
    if (idGet) {
      setId(idGet);
      getFetchData(idGet);
    }
  }, [idGet]);

  const handleCountryChange = (e) => {
    const selectedCountry =
      countriesList && countriesList.find((item) => item.id == e.target.value);
    setCountryId(selectedCountry.id);
    setFormValues((prevValue) => ({
      ...prevValue,
      country: selectedCountry.name,
      state: "",
      city: "",
    }));
    GetState(selectedCountry.id).then((result) => {
      setStateList(result);
      setCityList([]);
    });
  };

  const handleStateChange = (e) => {
    const selectedState =
      stateList && stateList.find((item) => item?.id == e.target.value);
    setStateId(selectedState.id);
    setFormValues((prevValue) => ({
      ...prevValue,
      state: selectedState.name,
      city: "",
    }));
    GetCity(countryId, selectedState.id).then((result) => {
      setCityList(result);
    });
  };

  const handleCityChange = (e) => {
    const selectedCity =
      cityList && cityList.find((item) => item?.id == e.target.value);
    setCityId(selectedCity.id);
    setFormValues((prevValue) => ({
      ...prevValue,
      city: selectedCity.name,
    }));
  };

  useEffect(() => {
    const checkValidation = postJobValid(formValues);
    if (!checkValidation.status) {
      setErrors(checkValidation.errors);
    } else {
      setErrors({});
    }
  }, [formValues]);

  const pathProfilePage = () => {
    window.location.assign("/school-profile");
  };

  const workModesList = ["Remote", "Hybrid", "Office"];

  const handleChangeQualifications = (e) => {
    const inputValue = e.target.value;
    setQualification(e.target.value);

    if (inputValue?.includes(",")) {
      const splitValue = inputValue.split(",");
      const firstValueCap =
        splitValue[0][0].toUpperCase() + splitValue[0].slice(1);
      if (qualifications?.includes(firstValueCap)) {
        toastError(`Already Exiting Qualification ${firstValueCap}`);
        setQualification("");
      } else {
        const firstValueCap =
          splitValue[0][0].toUpperCase() + splitValue[0].slice(1);
        setQualifications([...qualifications, firstValueCap]);
        setQualification("");
      }
    }
  };

  const handleFilterQualifications = (id) => {
    const filterOldValue = qualifications?.filter((item, index) => item !== id);
    setQualifications(filterOldValue);
  };

  const handleChangeKeySkills = (e) => {
    const inputValue = e.target.value;
    setKeySkill(e.target.value);
    if (inputValue?.includes(",")) {
      const splitValue = inputValue.split(",");
      const firstValueCap =
        splitValue[0][0].toUpperCase() + splitValue[0].slice(1);
      if (keyskills?.includes(firstValueCap)) {
        toastError(`Already Exiting Key Skill ${firstValueCap}`);
        setKeySkill("");
      } else {
        const firstValueCap =
          splitValue[0][0].toUpperCase() + splitValue[0].slice(1);
        setKeySkills([...keyskills, firstValueCap]);
        setKeySkill("");
      }
    }
  };

  const handleFilterKeySkills = (id) => {
    const filterOldValue = keyskills?.filter((item, index) => item !== id);
    setKeySkills(filterOldValue);
  };

  const [categorydata, setCategoryData] = useState([]);
  const [modalClose, setModalClose] = useState(null);

  const getCategoryData = async () => {
    try {
      const response = await GetJobCategories();
      if (response) {
        setCategoryData(response?.result);
      }
    } catch (error) {}
  };

  useEffect(() => {
    getCategoryData();
  }, []);

  const keyEnterCheck = (e) => {
    if (e.key === "Enter") {
      handleChangeQualifications(e);
    }
  };

  useEffect(() => {}, []);

  return (
    <>
      {Object.values(user?.contactDetails || {})?.some(
        (item, index) => item?.length > 0
      ) ||
      Object.values(user?.profileDetail || {})?.every(
        (item, index) => item?.length > 0
      ) ? (
        <>
          {status == "Pending" && (
            <>
              <div className="mt-5 text-center fw-bold fs-4 mb-5">
                Waiting for admin approval on your profile.
              </div>
            </>
          )}
        </>
      ) : (
        <>
          <div className="mt-5 text-center fw-bold fs-4 mb-5 d-flex align-items-center justify-content-center gap-3">
            <span style={{ color: "#96144d" }}>
              <i class="fa-solid fa-user"></i>
            </span>{" "}
            Please complete your profile
          </div>
        </>
      )}
      {/* {status == "Pending" && (
        <>
          <div className="mt-5 text-center fw-bold fs-4 mb-5">
            Waiting for admin approval on your profile.
          </div>
        </>
      )} */}
      {status == "Approved" && (
        <>
          <form className="default-form" onSubmit={handleSubmit}>
            <div className="row">
              {/* <!-- Input --> */}
              <div className="form-group col-lg-6 col-md-12">
                <div className="d-flex justify-content-between">
                  <label className="fs-6 fw-medium">
                    Job Category <span className="text-danger">*</span>
                  </label>
                  <label
                    className="cursor"
                    // data-bs-toggle="modal"
                    // data-bs-target="#staticBackdrop"
                    onClick={handleShow}
                    style={{
                      cursor: "pointer",
                      color: "#97144d",
                      fontWeight: "500",
                    }}
                  >
                    + Add New Category
                  </label>
                </div>
                {/* <input  
            type="text"
            name="JobCategory"
            placeholder="Enter Job Category"
            value={JobCategory}
            onBlur={handleBlur}
            onChange={handleChange}
          /> */}

                <select
                  className="chosen-single form-select"
                  name="JobCategory"
                  value={JobCategory}
                  onBlur={handleBlur}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Select Job Category
                  </option>

                  {categorydata?.map((item, index) => {
                    return <option value={item?._id}>{item?.category}</option>;
                  })}
                  {/* <option value="Full Time">Full Time</option>
            <option value="Part Time">Part Time</option>
            <option value="Contract">Contract</option> */}
                </select>
                {touched?.JobCategory && (
                  <span className="text-danger">{errors.JobCategory}</span>
                )}
              </div>

              {/* <!-- Input --> */}
              <div className="form-group col-lg-6 col-md-12">
                <label>
                  Email ID <span className="text-danger">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  placeholder="Enter recruiter Email ID"
                  value={email}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
                {touched?.email && (
                  <span className="text-danger">{errors.email}</span>
                )}
              </div>

              {/* <!-- About Company --> */}
              <div className="form-group col-lg-12 col-md-12 mb-5">
                <label>
                  Job Description <span className="text-danger">*</span>
                </label>
                {/* <textarea
                  type="text"
                  name="description"
                  value={description}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  placeholder="eg Sample JD:
We are looking for a 3+ years skilled Full Stack Developer (MERN) to design, develop, and maintain scalable web applications. The ideal candidate should have expertise in both front-end and back-end development, ensuring seamless integration between UI components and server-side logic.
Responsibilities:
    Develop and maintain responsive web applications using React.js / Next.js.Build and optimize backend services using Node.js, Express.js, and MongoDB/MySQL.Integrate third-party APIs and handle authentication using OAuth, JWT.
    Collaborate with UI/UX designers and other team members to deliver a seamless user experience.
Requirements:
    Front-end: React.js, Next.js, JavaScript (ES6+), Redux, Tailwind CSS,Back-end: Node.js, Express.js, REST APIs, GraphQL (optional).
    Database: MongoDB, MySQL, or PostgreSQL,Tools & DevOps: Git, GitHub, Docker, AWS (EC2, S3, Lambda).
    Authentication: JWT, OAuth, Firebase Auth.Bonus Skills: TypeScript, Microservices, CI/CD pipelines.
          "
                  style={{
                    minHeight: "400px",
                    width: "100%",
                    resize: "none",
                    overflow: "hidden",
                    overflowY: "auto",
                  }}
                ></textarea> */}

                {/* <JoditEditor
                  value={content}
                  config={config}
                  tabIndex={1}
                  onBlur={onBlur}
                  onChange={onChange}
                /> */}

                <ReactQuill
                  value={content}
                  onChange={setContent}
                  theme="snow"
                  placeholder="eg: Seeking a Full Stack Developer (MERN) with 3+ yrs exp in React, Node, MongoDB/MySQL. Must build scalable apps, integrate APIs.

Skills: React, Next.js, Node.js, Express, REST APIs, MongoDB/MySQL, JWT, OAuth, Git, Docker, AWS. Bonus: TypeScript, CI/CD.
"
                  //             placeholder="eg Sample JD:
                  // We are looking for a 3+ years skilled Full Stack Developer (MERN) to design, develop, and maintain scalable web applications. The ideal candidate should have expertise in both front-end and back-end development, ensuring seamless integration between UI components and server-side logic.
                  // Responsibilities:
                  //     Develop and maintain responsive web applications using React.js / Next.js.Build and optimize backend services using Node.js, Express.js, and MongoDB/MySQL.Integrate third-party APIs and handle authentication using OAuth, JWT.
                  //     Collaborate with UI/UX designers and other team members to deliver a seamless user experience.
                  // Requirements:
                  //     Front-end: React.js, Next.js, JavaScript (ES6+), Redux, Tailwind CSS,Back-end: Node.js, Express.js, REST APIs, GraphQL (optional).
                  //     Database: MongoDB, MySQL, or PostgreSQL,Tools & DevOps: Git, GitHub, Docker, AWS (EC2, S3, Lambda).
                  //     Authentication: JWT, OAuth, Firebase Auth.Bonus Skills: TypeScript, Microservices, CI/CD pipelines.
                  //           "
                  className="custom-quill"
                />

                {/* {touched?.description && (
                  <span className="text-danger">{errors.description}</span>
                )} */}
              </div>

              {/* <!-- Input --> */}
              {/* <div className="form-group col-lg-6 col-md-12">
          <label>Contact User Name</label>
          <input
            type="text"
            name="userName"
            placeholder="contact userName"
            value={userName}
            onBlur={handleBlur}
            onChange={handleChange}
          />
          {touched?.userName && (
            <span className="text-danger">{errors.userName}</span>
          )}
        </div> */}
              <div className="form-group col-lg-6 col-md-12 mt-2">
                <label>
                  Job Title <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="title"
                  placeholder="Title"
                  value={title}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
                {touched?.title && (
                  <span className="text-danger">{errors.title}</span>
                )}
              </div>
              <div className="form-group col-lg-6 col-md-12 mt-2">
                <label>
                  Experience (Years) <span className="text-danger">*</span>
                </label>
                <div className="d-flex gap-2">
                  <input
                    type="text"
                    name="experienceFrom"
                    placeholder="From (e.g., 1)"
                    value={experienceFrom}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    maxLength={2}
                  />
                  <input
                    type="text"
                    name="experienceTo"
                    placeholder="To (e.g., 3)"
                    value={experienceTo}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    maxLength={2}
                  />
                </div>
                {touched.experienceFrom && errors.experienceFrom && (
                  <span className="text-danger">{errors.experienceFrom}</span>
                )}
                {touched.experienceTo && errors.experienceTo && (
                  <span className="text-danger">{errors.experienceTo}</span>
                )}
              </div>

              {/* <!-- Search Select --> */}
              <div className="form-group col-lg-6 col-md-12">
                <div className="d-flex justify-content-between">
                  <label className="fs-6 fw-medium">
                    Languages <span className="text-danger">*</span>{" "}
                  </label>
                  <label
                    className="cursor"
                    // data-bs-toggle="modal"
                    // data-bs-target="#staticBackdrop"
                    onClick={handleShow1}
                    style={{
                      cursor: "pointer",
                      color: "#97144d",
                      fontWeight: "500",
                    }}
                  >
                    + Add New Language{" "}
                  </label>
                </div>

                <Select
                  isMulti
                  name="skills"
                  value={skills}
                  options={specialisms}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  onChange={handleSelectChange}
                  onBlur={handleSelectBlur}
                />
                {touched.skills && (
                  <span className="text-danger">{errors.skills}</span>
                )}
              </div>

              <div className="form-group col-lg-6 col-md-12">
                <label>
                  Employment Type <span className="text-danger">*</span>
                </label>
                <select
                  className="chosen-single form-select"
                  name="employmentType"
                  value={employmentType}
                  onBlur={handleBlur}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Select Employment Type
                  </option>
                  <option value="Full Time">Full Time</option>
                  <option value="Part Time">Part Time</option>
                  <option value="Contract">Contract</option>
                </select>
                {touched.employmentType && (
                  <span className="text-danger">{errors.employmentType}</span>
                )}
              </div>

              <div className="form-group col-lg-6 col-md-12">
                <label>
                  Gender Prefrence for the job{" "}
                  <span className="text-danger">*</span>
                </label>
                <select
                  className="chosen-single form-select"
                  name="gender"
                  value={gender}
                  onBlur={handleBlur}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Select Gender
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Both">Both</option>
                </select>
                {touched.gender && (
                  <span className="text-danger">{errors.gender}</span>
                )}
              </div>

              <div className="form-group col-lg-6 col-md-12">
                <label>
                  Work Mode <span className="text-danger">*</span>
                </label>
                <select
                  className="chosen-single"
                  name="workType"
                  value={workType}
                  onBlur={handleBlur}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Select Work Mode
                  </option>

                  {workModesList?.map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}
                  {/* <option value="CLASS_ROOM">Class Room</option> */}
                </select>
                {touched.workType && (
                  <span className="text-danger">{errors.workType}</span>
                )}
              </div>

              <div className="form-group col-lg-6 col-md-12">
                <label>
                  Qualification -{" "}
                  <span className="text-danger">(comma separated) </span>{" "}
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="qualification"
                  placeholder="eg. BCA, MCA, Eng, BE, Any Degree, Graduate, Post Graduate..."
                  value={qualification}
                  // onBlur={handleBlur}
                  onChange={handleChangeQualifications}
                  onKeyDown={keyEnterCheck}
                />
                {/* {touched.qualification && (
            <span className="text-danger">{errors.qualification}</span>
          )} */}

                <div className={styles.qualificationsbox}>
                  {qualifications?.map((item, index) => {
                    return (
                      <div
                        className={styles.insideboxqual}
                        style={{ fontSize: "13px", fontWeight: "500" }}
                      >
                        <div
                          className={styles.insidelatime}
                          onClick={() => handleFilterQualifications(item)}
                        >
                          <i className={`la la-times`}></i>
                        </div>
                        {item}
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* <!-- Input --> */}
              <div className="form-group col-lg-6 col-md-12">
                <label>
                  Application Deadline Date{" "}
                  <span className="text-danger">*</span>{" "}
                </label>
                <input
                  className="w-100 p-3 rounded-2"
                  style={{ backgroundColor: "#f0f5f7" }}
                  type="date"
                  name="deadlineDate"
                  placeholder="06.04.2020"
                  value={formValues.deadlineDate}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
                {touched.deadlineDate && (
                  <span className="text-danger">{errors.deadlineDate}</span>
                )}
              </div>

              <div className="form-group col-lg-6 col-md-12">
                <label>
                  Key Skills -{" "}
                  <span className="text-danger">(comma separated)</span>{" "}
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="qualification"
                  placeholder="eg. Reactjs, Nodejs, HTML"
                  value={keyskill}
                  // onBlur={handleBlur}
                  onChange={handleChangeKeySkills}
                />
                {/* {touched.qualification && (
            <span className="text-danger">{errors.qualification}</span>
          )} */}

                <div className={styles.qualificationsbox}>
                  {keyskills?.map((item, index) => {
                    return (
                      <div
                        className={styles.insideboxqual}
                        style={{ fontSize: "13px", fontWeight: "500" }}
                      >
                        <div
                          className={styles.insidelatime}
                          onClick={() => handleFilterKeySkills(item)}
                        >
                          <i className={`la la-times`}></i>
                        </div>
                        {item}
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="form-group col-lg-6 col-md-12">
                <label>
                  No of Openings <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="openings"
                  placeholder=" eg 100"
                  value={openings}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
                {touched?.openings && (
                  <span className="text-danger">{errors.openings}</span>
                )}
              </div>

              <div className="form-group col-lg-6 col-md-12">
                <div className="col-lg-12 row">
                  <div className="col-lg-6">
                    <label className="fw-medium fs-6">
                      Min Salary (LPA) <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="salaryRangeMin"
                      placeholder="eg  2 LPA"
                      value={salaryRangeMin}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                    {touched.salaryRangeMin && (
                      <span className="text-danger">
                        {errors.salaryRangeMin}
                      </span>
                    )}
                  </div>

                  <div className="col-lg-6">
                    <label className="fw-medium fs-6">
                      Max Salary (LPA) <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="salaryRangeMax"
                      placeholder="eg 6 LPA"
                      value={salaryRangeMax}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                    {touched.salaryRangeMax && (
                      <span className="text-danger">
                        {errors.salaryRangeMax}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div className="form-group col-lg-6 col-md-12">
                <label>
                  Country <span className="text-danger">*</span>
                </label>
                <select
                  name="country"
                  onChange={handleCountryChange}
                  value={countryId}
                  onBlur={handleBlur}
                >
                  <option value="" disabled>
                    Select country
                  </option>
                  {countriesList.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
                {touched?.country && (
                  <span className="text-danger">{errors.country}</span>
                )}
              </div>

              <div className="form-group col-lg-6 col-md-12">
                <label>
                  State <span className="text-danger">*</span>
                </label>
                <select
                  name="state"
                  onChange={handleStateChange}
                  value={stateId}
                  onBlur={handleBlur}
                >
                  <option value="" disabled>
                    Select state
                  </option>
                  {stateList.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
                {touched?.state && (
                  <span className="text-danger">{errors.state}</span>
                )}
              </div>

              <div className="form-group col-lg-6 col-md-12">
                <label>
                  City <span className="text-danger">*</span>
                </label>
                <select
                  name="city"
                  onChange={handleCityChange}
                  value={cityId}
                  onBlur={handleBlur}
                >
                  <option value="" disabled>
                    Select city
                  </option>
                  {cityList.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
                {touched?.city && (
                  <span className="text-danger">{errors.city}</span>
                )}
              </div>

              <div className="form-group col-lg-6 col-md-12">
                <label>
                  Contact No <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="phoneNo"
                  placeholder="Enter your Contact No"
                  value={phoneNo}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  maxLength={10}
                />
                {touched.phoneNo && (
                  <span className="text-danger">{errors.phoneNo}</span>
                )}
              </div>
              <div className="form-group col-lg-6 col-md-12">
                <label>
                  Website internal career portal references{" "}
                  <span style={{ color: "grey" }}>(Optional)</span>
                </label>
                <input
                  type="text"
                  name="website"
                  placeholder="https://www.yourcompany.career.html/"
                  value={website}
                  // onBlur={handleBlur}
                  onChange={handleChange}
                />
                {/* {touched.website && (
              <span className="text-danger">{errors.website}</span>
            )} */}
              </div>

              {/* <!-- Input --> */}

              {/* <div className="form-group col-lg-6 col-md-12">
            <label>
              Job Status <span className="text-danger">*</span>
            </label>
            <select
              className="chosen-single form-select"
              name="jobStatus"
              value={jobStatus}
              onBlur={handleBlur}
              onChange={handleChange}
            >
              <option value="" disabled>
                Select Job Status
              </option>
              <option value="active">Active</option>
              <option value="deactive">Deactive</option>
              <option value="withdrawn">Withdraw</option>
              <option value="draft">Draft</option>
            </select>

            {touched.jobStatus && (
              <span className="text-danger">{errors.jobStatus}</span>
            )}
          </div> */}

              <div className="form-group col-lg-6 col-md-12">
                <label>
                  Time Line <span className="text-danger">*</span>
                </label>
                <select
                  className="chosen-single form-select"
                  name="timeline"
                  value={timeline}
                  onBlur={handleBlur}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Select Time Line
                  </option>
                  <option value="Immediate Hiring">Immediate Hiring</option>
                  <option value="Within 30 Days">Within 30 Days</option>
                  <option value="30-60 Days">30-60 Days</option>
                </select>

                {touched.timeline && (
                  <span className="text-danger">{errors.timeline}</span>
                )}
              </div>
              <div className="form-group col-lg-6 col-md-12">
                <label>
                  Address for reporting <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="address"
                  placeholder="eg Chennai - 600078."
                  value={address}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
                {touched.address && (
                  <span className="text-danger">{errors.address}</span>
                )}
              </div>

              <>
                <div className="form-group col-lg-12 col-md-12 text-right d-flex align-items-center justify-content-center w-100">
                  {status == "Pending" ? (
                    <>
                      <button className="theme-btn btn-style-one" disabled>
                        Waiting for approval in your profile, and then you can
                        post jobs...!
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        className="theme-btn btn-style-one"
                        type="submit"
                        // style={!isEmpty(errors) ? { cursor: "not-allowed" } : {}}
                        // disabled={!isEmpty(errors)}
                      >
                        {idGet ? "Update Your Job" : "Create Job"}
                      </button>
                    </>
                  )}
                </div>
              </>
            </div>
          </form>

          <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Create Category</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Createcategory
                setModalClose={setModalClose}
                setCategoryData={setCategoryData}
                handleCloseModal={handleClose}
              />
            </Modal.Body>
          </Modal>

          <Modal
            show={show1}
            onHide={handleClose1}
            backdrop="static"
            keyboard={false}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Create Language</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <CreateLanguage
                setCategoryData={setSpecialisms}
                handleCloseModal={handleClose1}
              />
            </Modal.Body>
          </Modal>
        </>
      )}
    </>
  );
};

export default PostBoxForm;
